import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import Churches from './marque/Churches';
import Districts from './marque/Districts';

const StyledTypography = styled(Typography)(({ theme }) => ({
  height: 150,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  [theme.breakpoints.up('lg')]: {
    height: 578,
  },
  backgroundColor: theme.palette.mode === 'dark' ? '#3e4244' : '#a9a9a9',
}));

export default function Marque() {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 10 }}>
      <Grid container spacing={0}>
        <Grid item xs={12} lg={4}>
          <StyledTypography>
            <Box>
              <Typography variant="h3">“ወደ እግዚአብሔር ቤት እንሂድ” ባሉኝ ጊዜ፣ ደስ አለኝ።</Typography>
              <Typography variant="h4"> መዝሙር 122:1 </Typography>
            </Box>
          </StyledTypography>
        </Grid>
        <Grid item xs={12} lg={8}>
          {theme.palette.mode === 'dark' ? (
            <>
              <Districts gradientColor="#3e4244" />
              <Churches gradientColor="#3e4244" />
            </>
          ) : (
            <>
              <Districts gradientColor="#a9a9a9" />
              <Churches gradientColor="#a9a9a9" />
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
